import { render } from "./Details-item.vue?vue&type=template&id=484f51e3"
import script from "./Details-item.vue?vue&type=script&lang=js"
export * from "./Details-item.vue?vue&type=script&lang=js"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__